/*
  WECI – Venta por rollo (solo interfaz).
  Ajusta la casilla de cantidad de los cables que se venden por rollo
  (metafield custom.incremento_rollo): empieza en el tamaño del rollo y
  sube/baja en múltiplos de ese tamaño. No toca precios, B2B, carrito ni checkout.
  Si el cliente ya tiene una regla B2B (step > 1), no se modifica nada.
*/
(function () {
  var KEY = 'weciRollQty';

  function loadMap() {
    var map = {};
    try { map = JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) { map = {}; }
    var el = document.getElementById('weci-roll-qty-data');
    if (el) {
      try {
        var data = JSON.parse(el.textContent);
        for (var k in data) { if (k !== '_' && data[k] > 1) map[k] = data[k]; }
      } catch (e) {}
    }
    try { sessionStorage.setItem(KEY, JSON.stringify(map)); } catch (e) {}
    return map;
  }

  var MAP = loadMap();

  function incFor(id) {
    var n = parseInt(MAP[String(id)], 10);
    return n > 1 ? n : 0;
  }

  function stepOf(input) {
    var s = parseInt(input.getAttribute('step'), 10);
    return isNaN(s) ? 1 : s;
  }

  function formFor(input) {
    var formId = input.getAttribute('form');
    return formId ? document.getElementById(formId) : input.closest('form');
  }

  function roundUp(value, n) {
    var v = parseInt(value, 10);
    if (isNaN(v) || v < n) return n;
    return Math.ceil(v / n) * n;
  }

  // Página de producto y ventana de "agregar rápido": input name="quantity"
  function applyProductInputs(root) {
    root.querySelectorAll('input[name="quantity"]').forEach(function (q) {
      if (q.type === 'hidden') return;
      var form = formFor(q);
      if (!form) return;
      var idEl = form.querySelector('[name="id"]');
      if (!idEl) return;
      var n = incFor(idEl.value);
      if (!n) return;
      var step = stepOf(q);
      if (step === n) return;          // ya aplicado
      if (step > 1) return;            // regla B2B existente: no tocar
      q.setAttribute('min', n);
      q.setAttribute('step', n);
      q.setAttribute('data-min', n);
      q.value = roundUp(q.value, n);
      q.setAttribute('data-weci-roll', n);
    });
  }

  // Botones de agregar rápido en tarjetas de producto (sin casilla de cantidad)
  function applyQuickAddForms(root) {
    root.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      // No tocar el formulario de cuotas (Shop Pay Installments) ni otros que no sean "agregar al carrito"
      if (form.classList.contains('installment')) return;
      var idEl = form.querySelector('[name="id"]');
      if (!idEl) return;
      var n = incFor(idEl.value);
      if (!n) return;
      if (form.querySelector('[name="quantity"]')) return;
      // form.id puede estar tapado por el input name="id"; usar el atributo real
      var formId = form.getAttribute('id');
      if (formId && document.querySelector('input[name="quantity"][form="' + formId + '"]')) return;
      var h = document.createElement('input');
      h.type = 'hidden';
      h.name = 'quantity';
      h.value = n;
      h.setAttribute('data-weci-roll', n);
      form.appendChild(h);
    });
  }

  // Carrito y carrito lateral: input con data-quantity-variant-id
  function applyCartInputs(root) {
    root.querySelectorAll('input[data-quantity-variant-id]').forEach(function (q) {
      if (q.name === 'quantity') return;
      var n = incFor(q.getAttribute('data-quantity-variant-id'));
      if (!n) return;
      var step = stepOf(q);
      if (step === n) return;
      if (step > 1) return;
      q.setAttribute('step', n);
      q.setAttribute('data-min', n);
      q.setAttribute('data-weci-roll', n);
    });
  }

  function run() {
    try {
      applyProductInputs(document);
      applyQuickAddForms(document);
      applyCartInputs(document);
    } catch (e) {}
  }

  // Si el cliente escribe una cantidad a mano en la página de producto, se redondea al rollo
  document.addEventListener('change', function (e) {
    var q = e.target;
    if (!q || q.name !== 'quantity' || !q.hasAttribute('data-weci-roll')) return;
    var n = parseInt(q.getAttribute('data-weci-roll'), 10);
    if (n > 1) q.value = roundUp(q.value, n);
  }, true);

  function start() {
    run();
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(run, 50);
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['step'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
